import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#EF1412" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            {/* <CFLink href="https://www.facebook.com/pages/category/Sushi-Restaurant/Sushi-Modo-115886992366892/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sushi Oyama Facebook"
              />
            </CFLink> */}
            <CFLink href="https://www.yelp.ca/biz/sushi-oyama-burnaby-2">
              <CFImage w="40px" pr="10px" src={yelp} alt="Sushi Oyama Yelp" />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/sushi-oyama-central-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Sushi Oyama Zomato"
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/sushioyamarestaurant/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sushi Oyama Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#EF1412" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            {/* <CFLink href="https://www.facebook.com/pages/category/Sushi-Restaurant/Sushi-Modo-115886992366892/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sushi Oyama Facebook"
                hover
              />
            </CFLink> */}
            <CFLink href="https://www.yelp.ca/biz/sushi-oyama-burnaby-2">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Sushi Oyama Yelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/sushi-oyama-central-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Sushi Oyama Zomato"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/sushioyamarestaurant/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sushi Oyama Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
